"use client"

import { useState, useEffect } from "react"
import "./Footer.css"
import { FaHome } from "react-icons/fa"
import { Offcanvas, Spinner } from "react-bootstrap"
import AccountStatus from "../AccountStatus/AccountStatus"
import { useLocation, useNavigate } from "react-router-dom"
import LoginPopup from "../LoginPopup/LoginPopup"
import Helper from "../../helper"
import Login from "../Login/Login"
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import SignUp from "../SignUp/SignUp";

const Footer = () => {
  const location = useLocation()
  const myState = location.state?.myKey
  const [whatsappNum, setWhatsAppNumber] = useState("");

  const [showOffcanvas, setShowOffcanvas] = useState(false)
  const [showLoginPopup, setShowLoginPopup] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991)
  const [loading, setLoading] = useState(false) // 🔹 new state for loader
  const [showLoginModel, setShowLoginModel] = useState(false);

  const [showSignupModel, setShowSignupModel] = useState(false);
  const [showForgotModel, setShowForgotModel] = useState(false)

  const navigate = useNavigate()
  const [activeButton, setActiveButton] = useState("home")
  const userInfo = Helper()

  const handleButtonClick = (buttonName) => {
    switch (buttonName) {
      case "home":
        navigate("/", { state: { myKey: "home" } })
        setActiveButton(buttonName)
        break
      case "inplay":
        navigate("/", { state: { myKey: "inplay", subSport: "live" } })
        setActiveButton(buttonName)
        break
      case "casino":
        setLoading(true) // 🔹 show loader
        setActiveButton(buttonName)
        // simulate slight delay before navigation to show loader
        setTimeout(() => {
          navigate("/all-games-lobby", { state: { myKey: "casino" } })
          setLoading(false) // 🔹 hide loader after navigation
        }, 1000)
        break
      case "profile":
        navigate("/", { state: { myKey: "home", subSport: "profile" } })
        setActiveButton(buttonName)
        setShowOffcanvas(true)
        break
      default:
        break
    }
  }

  const handleClose = () => setShowOffcanvas(false)
  const handleLogout = () => {
    console.log("Logout clicked")
    setShowOffcanvas(false)
  }

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleLoginPopupClose = () => setShowLoginPopup(false)

  if (!isMobile) return null

  const togglePopup = (isClose = null) => {
    if (isClose == "Yes") {
      setShowLoginModel(false);
    } else {
      setShowLoginModel(!showLoginModel);
    }
    setShowForgotModel(false);
    setShowSignupModel(false);
    // setShowMenu(false);
  };
  const toggleForgotPopup = () => {
    setShowLoginModel(false);
    setShowSignupModel(false);
    setShowForgotModel(!showForgotModel);
    // setShowMenu(false);
  };

  const openWhatsApp = (whatsapp) => {
    const url = `https://wa.me/${whatsapp.replace(/\D/g, "")}`;
    window.open(url, "_blank");
  };

  const toggleSignUpPopup = () => {
    setShowLoginModel(false);
    setShowForgotModel(false);
    setShowSignupModel(!showSignupModel);
    // setShowMenu(false);
  };

  return (
    <>
      <Login
        showPopup={showLoginModel}
        togglePopup={togglePopup}
        whatsappNum={whatsappNum}
        openWhatsApp={openWhatsApp}
        toggleForgotPopup={toggleForgotPopup}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={handleClose}
      />

      <ForgotPassword
        showForgotPopup={showForgotModel}
        togglePopup={togglePopup}
        toggleForgotPopup={toggleForgotPopup}
        handleClose={handleClose}
      />
      <SignUp
        showSignupPopup={showSignupModel}
        togglePopup={togglePopup}
        whatsappNum={whatsappNum}
        openWhatsApp={openWhatsApp}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={handleClose}
      />

      {/* Loader Overlay */}
      {loading && (
        <div className="fixed inset-0 bg-white bg-opacity-60 flex items-center justify-center z-50">
          <img src="\Images\loader.gif" />
        </div>
      )}

      {/* Footer Navigation */}
      <nav className="navbar-footer fixed bottom-0 w-full bg-gray-900 text-white py-2 z-40">
        <div className="footer-icons flex justify-around items-center">
          {/* Home Button */}
          <button
            className={`flex flex-row gap-1 items-center px-4 py-2 rounded-full transition duration-300 ${myState === "home" ? "bg-[#21ABCD]" : ""
              }`}
            onClick={() => handleButtonClick("home")}
          >
            <FaHome size={20} color="#fff" />
            {myState === "home" && (
              <p className="text-[14px] font-bold text-white">Home</p>
            )}
          </button>

          {/* In-Play Button */}
          <button
            className={`flex flex-row gap-1 items-center px-4 py-2 rounded-full transition duration-300 ${myState === "inplay" ? "bg-[#21ABCD]" : ""
              }`}
            onClick={() => handleButtonClick("inplay")}
          >
            <img
              src="https://images.staticcontent.io/rde/uimg/inplay.svg"
              className="h-6 w-6"
              alt="In-Play"
            />
            {myState === "inplay" && (
              <p className="text-[14px] font-bold text-white">in-play</p>
            )}
          </button>

          {/* Casino Button */}
          <button
            className={`flex flex-row gap-1 items-center px-4 py-2 rounded-full transition duration-300 ${myState === "casino" ? "bg-[#21ABCD]" : ""
              }`}
            onClick={() => {
              if (userInfo) {
                // navigate("/all-games-lobby", { state: { activeCasino: casinoType } });
                handleButtonClick("casino")
              } else {
                // setShowMenu(false);
                setShowLoginModel(true);
              }
            }}
          >
            <img
              src="https://images.staticcontent.io/rde/uimg/mini_games.gif"
              alt="Mini Games"
              className="w-6 h-6 object-contain"
            />
            {myState === "casino" && (
              <p className="text-[14px] font-bold text-white">Casino</p>
            )}
          </button>

          {/* Profile Button */}
          <button
            className={`flex flex-row gap-1 items-center px-4 py-2 rounded-full transition duration-300 ${myState === "profile" ? "bg-[#21ABCD]" : ""
              }`}
            onClick={() => handleButtonClick("profile")}
          >
            <img
              src="https://images.staticcontent.io/rde/uimg/menu.svg"
              className="h-7 w-7"
              alt="Profile"
            />
            {myState === "profile" && (
              <p className="text-[14px] font-bold text-white">Profile</p>
            )}
          </button>
        </div>
      </nav>

      {/* Login Popup */}
      {showLoginPopup && <LoginPopup onClose={handleLoginPopupClose} />}

      {/* Fullscreen Offcanvas */}
      <Offcanvas
        show={showOffcanvas}
        onHide={handleClose}
        placement="end"
        className="offcanvas-fullscreen"
        style={{ maxWidth: "400px" }}
      >
        <Offcanvas.Header closeButton className=" bg-[#045662] "></Offcanvas.Header>
        <Offcanvas.Body>
          <AccountStatus
            handleClose={handleClose}
            userInfo={userInfo}
            handleLogout={handleLogout}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Footer
